import axios from "axios";
import { logout } from "../lib/auth";
import { accountTableColumn } from "../config/account";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

//  顧客一覧取得
export async function getAccounts(props: { [key: string]: number | string }) {
  try {
    const path = "accounts";
    let params = makeParams(accountTableColumn.dataColumn, props);
    params = {
      ...params,
      thisYear: props.thisYear,
      thisMonth: props.thisMonth,
      lastYear: props.lastYear,
      lastMonth: props.lastMonth,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const accounts: dataDifine[] = response.data.fetch_data;
    const countAccounts: string = response.data.count_data;
    return { accounts, countAccounts };
  } catch (error) {
    // logout();
  }
}

// 顧客詳細取得
export async function getAccount(
  id: string,
  thisYear: string,
  thisMonth: string,
  lastYear: string,
  lastMonth: string
) {
  try {
    const path = "account";
    const params = { id, thisYear, thisMonth, lastYear, lastMonth };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
  }
}

// 顧客情報編集
export async function putAccount(editData: EditDataDifine) {
  try {
    const path = "account";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiCognitoUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 顧客情報登録
export async function postAccount(addData: {
  [key: string]: string | boolean | any[];
}): Promise<{ add: string; temp_password?: string; email?: string; account_name?: string } | undefined> {
  try {
    const path = "account";
    const bodys = addData;
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data;
  } catch (error) {
    // logout();
  }
}

// パートナー配下のアカウント一覧取得（体制図用）
export async function getAccountsBySaleCompany(saleCompanyName: string) {
  try {
    const path = "accounts";
    const params = {
      sale_company_name: saleCompanyName,
      displayNumber: 9999,
      pageNumber: 1,
    };
    const response = await axios.get(CONST.apiUrl + path, { params });
    if (response.data.fetch_data === "null" || response.data.fetch_data == null) {
      return [];
    }
    return response.data.fetch_data as dataDifine[];
  } catch (error) {
    return [];
  }
}

// アカウントパスワードリセット
export async function resetPasswordAccount(id: string): Promise<{ edit: string; temp_password?: string; email?: string; account_name?: string } | undefined> {
  try {
    const path = "account/resetPassword";
    const params = { id: id };
    const bodys = {
      id: id,
    };
    const response = await axios.put(CONST.apiCognitoUrl + path, {
      params,
      bodys,
    });
    return response.data;
  } catch (error) {
    // logout();
  }
}
